import { eventBusExample } from '@/sub-luca-plugin/utils/class-example';
import { getQaStore } from '@/sub-luca-plugin/store/qa';
import { luca_ask_ocr } from '@/sub-luca-plugin/apis/qa';

/**
 * 创建新问题
 */
export const createNewQuestion = () => {
    const { initConfig, qaConfig } = getQaStore()!;
    const { lucaId, initProjectId, initSubjectId, initTwoLevelSubjectId, disabledInitReverseSelectLevel } = initConfig.current;
    // 非学习空间场景下，以外部传入的项目、一级科目、二级科目初始化，且当前值不可反选更换
    const defaultIds = disabledInitReverseSelectLevel
        ? [initProjectId, initSubjectId, initTwoLevelSubjectId].filter(
              (item, index) => !!item && index <= disabledInitReverseSelectLevel - 1
          )
        : [qaConfig.projectId].filter(item => !!item);
    eventBusExample.publish('QaInitOverlay', {
        type: 'initByLucaId',
        params: { lucaId, defaultIds, allowChangeDeterminedIds: !disabledInitReverseSelectLevel },
    });
};

/**
 * 获取转名师的参数
 */
export const getTransformToTeacherParams = () => {
    const { qaRecords } = getQaStore()!;
    let llmStatus: 0 | 1 = 0;
    const content = qaRecords.reduce((str, item) => {
        const linebreaks = str === '' ? '' : '\n\n';
        if (item.type === 'basic') {
            let newStr = `${str}${linebreaks}[学员]：${item.content}`;
            if (item.pictures?.length) {
                newStr = item.pictures.reduce((str, url) => {
                    return `${str} ![用户图片](${url})`;
                }, `${newStr}\n`);
            }
            return newStr;
        }
        if (item.type === 'ocr') {
            return `${str}${linebreaks}[学员]： ![用户图片](${item.picture})`;
        }
        if (item.type === 'ai' && item.content) {
            llmStatus = 1;
            return `${str}${linebreaks}[Luca]：${item.content}`;
        }
        return str;
    }, '');
    return {
        recordType: 19,
        llmStatus,
        text: { content },
        images: [],
    };
};

export const searchQuestionByOcr = (cropUrl: string) =>
    new Promise(async resolve => {
        const { projectId, subjectId, twoLevelSubjectId } = getQaStore()!.qaConfig;
        const { result: content } = await luca_ask_ocr({ imageUrl: cropUrl, projectId, subjectId, twoLevelSubjectId });
        eventBusExample.publish('DialogueArea', {
            type: 'searchQuestionsByOcrContent',
            params: { recordType: 40, text: { belongType: 0, content: (content || '').slice(0, 5000) }, images: [cropUrl] },
            callbacks: {
                finish: (success: boolean) => {
                    if (success) {
                        getQaStore()!.updateQaConfig({ showSearchQuestionsByOcrBtn: false, showWhetherSolve: false });
                    }
                    resolve('finished');
                },
            },
        });
    });
